"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const Subject_1 = require("rxjs/Subject");
const profile_service_1 = require("../serviceAuthentication/profile.service");
const signalRServices_1 = require("./signalRServices");
const IInaxConfigService_interface_1 = require("../interfaces/IInaxConfigService.interface");
/**
 * When SignalR runs it will add functions to the global $ variable
 * that you use to create connections to the hub. However, in this
 * class we won't want to depend on any global variables, so this
 * class provides an abstraction away from using $ directly in here.
 */
class SignalrWindow extends Window {
}
exports.SignalrWindow = SignalrWindow;
var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["Connecting"] = 1] = "Connecting";
    ConnectionState[ConnectionState["Connected"] = 2] = "Connected";
    ConnectionState[ConnectionState["Reconnecting"] = 3] = "Reconnecting";
    ConnectionState[ConnectionState["Disconnected"] = 4] = "Disconnected";
})(ConnectionState = exports.ConnectionState || (exports.ConnectionState = {}));
let InaxSignalR = class InaxSignalR {
    constructor(_hubServices, _configurationService, _window, _profileService) {
        this._hubServices = _hubServices;
        this._configurationService = _configurationService;
        this._window = _window;
        this._profileService = _profileService;
        this._hubConnection = null;
        this._connectionStateSubject = new Subject_1.Subject();
        this._startingSubject = new Subject_1.Subject();
        this._errorSubject = new Subject_1.Subject();
        this._initialized = false;
        this._state = ConnectionState.Disconnected;
        this._hubProxies = {};
        this._subscribtionId = _profileService.addSubscriber(() => this.start());
        this._configSubscription = _configurationService
            .getConfiguration()
            .subscribe((configSettings) => {
            //TODO: may use the interface !!!
            this._configuration = _configurationService;
            if (configSettings.UseSignalR)
                this.initialize();
            else
                this.release();
        });
    }
    get isInitialized() {
        return this._initialized;
    }
    get state() {
        return this._state;
    }
    isHubConnected(hubName) {
        if (this._hubProxies[hubName] != null) {
            return this.state == ConnectionState.Connected;
        }
        return false;
    }
    /**
     * stop signalR
     */
    release() {
        try {
            if (this._hubConnection != null) {
                this._hubConnection.stop();
                this._initialized = false;
            }
        }
        catch (error) {
            console.error(`Could not stop SignalR because of an error: ${error}`);
        }
    }
    /**
     * initialize the components
     */
    initialize() {
        if (this._window.$ === undefined || this._window.$.hubConnection === undefined) {
            throw new Error("The variable '$' or the .hubConnection() function are not defined...please check the SignalR scripts have been loaded properly");
        }
        // Set up our observables
        this.connectionState = this._connectionStateSubject.asObservable();
        this.error = this._errorSubject.asObservable();
        this.starting = this._startingSubject.asObservable();
        this._hubConnection = this._window.$.hubConnection();
        this._hubConnection.url = this._configuration.ServerWithSignalRUrl;
        this.createHubProxies();
        // Define handlers for the connection state events
        this._hubConnection.stateChanged((state) => {
            let newState = ConnectionState.Connecting;
            switch (state.newState) {
                case this._window.$.signalR.connectionState.connecting:
                    newState = ConnectionState.Connecting;
                    break;
                case this._window.$.signalR.connectionState.connected:
                    newState = ConnectionState.Connected;
                    break;
                case this._window.$.signalR.connectionState.reconnecting:
                    newState = ConnectionState.Reconnecting;
                    break;
                case this._window.$.signalR.connectionState.disconnected:
                    newState = ConnectionState.Disconnected;
                    break;
            }
            // Push the new state on our subject
            this._state = newState;
            this._connectionStateSubject.next(newState);
        });
        // Define handlers for any errors
        this._hubConnection.error((error) => {
            // Push the error on our subject
            this._errorSubject.next(error);
        });
        this._hubServices.forEach(service => {
            if (service != null) {
                service.registerEvents(this);
            }
        });
        if (this._profileService.ensureAuthenticated()) {
            this.start();
        }
        this._initialized = true;
    }
    /**
     * creats a hubproxy with the given name.
     */
    createHubProxy(name) {
        if (this._hubConnection != null)
            return this._hubConnection.createHubProxy(name);
        return null;
    }
    createHubProxies() {
        this._configuration.EnabledSignalRHubs.forEach(element => {
            this._hubProxies[element] = this.createHubProxy(element);
        });
    }
    getHubProxy(name) {
        return this._hubProxies[name];
    }
    /**
    * Start the SignalR connection. The starting$ stream will emit an
    * event if the connection is established, otherwise it will emit an
    * error.
    */
    start() {
        // Now we only want the connection started once, so we have a special
        //  starting$ observable that clients can subscribe to know know if
        //  if the startup sequence is done.
        //
        // If we just mapped the start() promise to an observable, then any time
        //  a client subscried to it the start sequence would be triggered
        //  again since it's a cold observable.
        let token = this._profileService.getToken();
        if (token != null)
            this._hubConnection.qs = { BearerToken: token };
        this._hubConnection.start()
            .done(() => {
            this._startingSubject.next(null);
        })
            .fail((error) => {
            this._startingSubject.error(error);
        });
    }
};
InaxSignalR = __decorate([
    core_1.Injectable(),
    __param(0, core_1.Inject(signalRServices_1.IHUBSERVICE_TOKEN)),
    __param(1, core_1.Inject(IInaxConfigService_interface_1.IINAXCONFIGSERVICE_TOKEN)),
    __metadata("design:paramtypes", [Array, Object, SignalrWindow,
        profile_service_1.ProfileService])
], InaxSignalR);
exports.InaxSignalR = InaxSignalR;
